module.exports = __webpack_public_path__ + "img/logotop.ec77c28a.png";